import { useState } from "react";
import { Button, Container, Grid, TextField, Typography } from "@mui/material";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import QUDProgress from "../../../../../components/progress";
import ResponseComponent from "../../../../../components/responseComponent";
import CustomBreadcrumbs from "../../../../../components/breadcrumbs";
import SectionTitle from "../../../../../components/sectionTitle";
import { createModifierOption } from "../../../../../controllers/company/products/ModifierOptionsController";


export default function ModifierOptionCreate()
{
    const [name,setName] = useState('');
    const [errorName,setErrorName] = useState(false);
    
    const [price,setPrice] = useState('');
    const [errorPrice,setErrorPrice] = useState(false);

    const [quantity,setQuantity] = useState(0);
    const [errorQuantity,setErrorQuantity] = useState(false);

    const [isLoading,setIsLoading] = useState(false);

    const [open,setOpen] = useState(false);
    const [title,setTitle] = useState('');
    const [message,setMessage] = useState('');
    const [success,setSuccess] = useState(false);

    const history = useHistory();
    const { modifierGroupId } = useParams();

    const formVerification = () => {
        let ban = 0;

        if(name === '')
        {
            setErrorName(true);
            ban = 1;
        }

        return ban;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        if(formVerification()===0)
        {
            setIsLoading(true);
            const response = await createModifierOption(modifierGroupId,name,price);
            if(response.success === true)
            {
                setTitle('Operación Exitosa');
                setMessage(response.message);
                setSuccess(true);
                setOpen(true);
            }
            else
            {
                setTitle('Operación Fallida');
                setMessage(response.message);
                setSuccess(false);
                setOpen(true);
            }

            setIsLoading(false);
        }
    }

    const handleClose = () => {
        setOpen(false);
        if(success === true)
        {
            history.push('/products/modifiergroups/options/'+modifierGroupId);
        }
    }

    return(
        <Container maxWidth='xl'>
            <CustomBreadcrumbs
                returnTo={`/products/modifiergroups/options/${modifierGroupId}`}
                crumbs={[
                    {name:'Productos',link:'/products'},
                    {name:'Extras',link:'/products/modifiergroups'},
                    {name:'Opciones',link:'/products/modifiersgroups/options/'+modifierGroupId},
                    {name:'Crear',link:`/products/modifiergroups/options/${modifierGroupId}/create`}
                ]}
            />
            <br/>
            <SectionTitle title='Crear Opción' subtitle={`(Extras)`} />

            <Grid container spacing={3} justifyContent={'center'}>
                <Grid item lg={4} xl={4}>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                label='Nombre'
                                fullWidth
                                value={name}
                                onChange={(e)=>setName(e.target.value)}
                                onBlur={()=>setErrorName(name==='')}
                                error={errorName}
                                helperText={errorName?<Typography>El nombre es obligatorio</Typography>:''}
                            />
                            <Typography style={{fontSize: 16, color: 'gray', marginTop: 4}}>
                                El nombre del extra individual que el cliente seleccionará. Ej: 'Bordado de Iniciales', 'Garantía de 2 Años', 'Extra Queso', 'Envoltura de Regalo'.
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label='Precio'
                                id="price"
                                name="price"
                                value={price}
                                onChange={(e)=>setPrice(e.target.value)}
                                onBlur={()=>setErrorPrice(price==='')}
                                error={errorPrice}
                                helperText={errorPrice?<Typography>El precio es obligatorio</Typography>:''}
                            />
                            <Typography style={{fontSize: 16, color: 'gray', marginTop: 4}}>
                                Define el costo adicional para esta opción. Si la opción no tiene costo extra o ya está incluida en el precio base, escribe 0.
                            </Typography>
                        </Grid>

                        
                    </Grid>
                    
                    <Button
                        fullWidth
                        variant="contained"
                        sx={{mt:2}}
                        onClick={(e)=>handleSubmit(e)}
                    >
                        <Typography>Crear opción</Typography>
                    </Button>

                    {/*<TextField
                                            fullWidth
                                            select
                                            id="idUnidad"
                                            name='idUnidad'
                                            label="Unidad de medida"
                                            variant="outlined"
                                            value = {idUnidad}
                                            onChange = { onChange }
                                            onBlur={ () => (idUnidad === '' ? setState({field:'errorIdUnidad',value:true}) : setState({field:'errorIdUnidad',value:false}) ) }
                                            error = {errorIdUnidad}
                                            helperText={errorIdUnidad && 'Seleccione la unidad de medida'}
                                        >
                                            <MenuItem value=''>Seleccione una unidad</MenuItem>
                                            {
                                                unidades.length !== 0 &&
                                                unidades.map((item)=>
                                                    <MenuItem value={item.idUnidad}>{item.nombre}</MenuItem>
                                                )
                                            }
                                        </TextField>*/}
                </Grid>
            </Grid>

            <QUDProgress open={isLoading}/>
            <ResponseComponent
                show={open}
                success={success}
                title={title}
                message={message}
                actionText={'Finalizar'}
                onClick={()=>handleClose()}
            />
        </Container>
    )
}